import { jsxs as u, jsx as t } from "react/jsx-runtime";
import "../../base-BUIxijjU.js";
import { useRef as h, useState as x } from "react";
import C from "../../core/hooks/useOutsideClick.js";
import { cssX as r } from "../../core/utils/css.js";
import { c as i } from "../../index-C7ezJk5b.js";
import S from "../Dropdown/Dropdown.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import B from "../TextInput/TextInput.js";
import "react-router-dom";
import { G as w } from "../../iconBase-DkR9t2l_.js";
function N(o) {
  return w({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }, child: [] }] })(o);
}
const V = ({
  testId: o,
  children: c,
  style: m,
  className: l,
  tooltipId: n,
  inputProps: s,
  dropdownProps: p,
  onClick: d
}) => {
  const a = h(null), [f, e] = x(!1);
  return C({
    ref: a,
    callback: () => e(!1)
  }), /* @__PURE__ */ u(
    "div",
    {
      ref: a,
      className: i(r("SearchBox"), l),
      "data-testid": o,
      style: m,
      "data-tooltip-id": n,
      onClick: d,
      children: [
        /* @__PURE__ */ t(
          B,
          {
            ...s,
            className: i(r("SearchBox__input"), s.className),
            onFocus: () => e(!0)
          }
        ),
        f && /* @__PURE__ */ t(S, { ...p }),
        c,
        /* @__PURE__ */ t(N, { className: r("SearchBox__icon") })
      ]
    }
  );
};
export {
  V as default
};
